import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

const DeleteSmsDialog = ({ open, onClose, onConfirm, announcement, isLoading }) => {
  const handleConfirm = () => {
    if (onConfirm && announcement) {
      onConfirm();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="error" />
          <Typography variant="h6">Confirm Delete SMS</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          This action cannot be undone. The SMS announcement will be permanently deleted.
        </Alert>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to delete this SMS announcement?
        </Typography>
        {announcement && (
          <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary">
              <strong>Title:</strong> {announcement.messageTitle || 'N/A'}
            </Typography>
            {announcement.messageDescription && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                <strong>Description:</strong>{' '}
                {announcement.messageDescription.length > 150
                  ? `${announcement.messageDescription.substring(0, 150)}...`
                  : announcement.messageDescription}
              </Typography>
            )}
            {announcement.messageBody && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                <strong>Message:</strong>{' '}
                {announcement.messageBody.length > 200
                  ? `${announcement.messageBody.substring(0, 200)}...`
                  : announcement.messageBody}
              </Typography>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={isLoading}
        >
          {isLoading ? 'Deleting...' : 'Delete SMS'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSmsDialog;
